import { render, staticRenderFns } from "./shoucang.vue?vue&type=template&id=a626fcd0&scoped=true&"
import script from "./shoucang.vue?vue&type=script&lang=js&"
export * from "./shoucang.vue?vue&type=script&lang=js&"
import style0 from "./shoucang.vue?vue&type=style&index=0&id=a626fcd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a626fcd0",
  null
  
)

export default component.exports